import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=1ba3111a&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=js&"
export * from "./SearchResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=1ba3111a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3111a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ba3111a')) {
      api.createRecord('1ba3111a', component.options)
    } else {
      api.reload('1ba3111a', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=1ba3111a&scoped=true&", function () {
      api.rerender('1ba3111a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/SearchResults.vue"
export default component.exports